import { render, staticRenderFns } from "./AccountTokenBalanceTable.vue?vue&type=template&id=49cb0f24&scoped=true"
import script from "./AccountTokenBalanceTable.vue?vue&type=script&lang=js"
export * from "./AccountTokenBalanceTable.vue?vue&type=script&lang=js"
import style0 from "./AccountTokenBalanceTable.vue?vue&type=style&index=0&id=49cb0f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb0f24",
  null
  
)

export default component.exports